import { call, put, select, take, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes";
import { sessionRefreshCall, validateApiTokenCall } from "../../apis/wpApi/apiCalls";
import authUser from "../../apis/wpApi/authUser";
import parseJWT from "../../functions/parseJWT";
import { putError, putSuccess } from "../helpers"
import { isSessionAlive, isSessionExpired, putCapsData, putSessionData, validSessionResponse } from "./sessionHelpers";


function* validateIfPossible(apiKey) {
    try { 
        const response = yield call(validateApiTokenCall, apiKey);

        if(
            !response
            || !response.hasOwnProperty('data') 
            || !response.data.hasOwnProperty('code')
            || "jwt_auth_valid_token" !== response.data.code
            || !response.data.hasOwnProperty('data')
            || !response.data.data.hasOwnProperty('status')
            || 200 !== response.data.data.status
        )  {
            throw new Error('Malformed API response')
        }
    } catch(e) {
        if(
            e.hasOwnProperty('response')  &&
            e.response.hasOwnProperty('data') &&
            e.response.data.hasOwnProperty('code') &&
            'jwt_auth_invalid_token' === e.response.data.code
        ) {
            throw new Error('Invalid token'  + (e.response.data.message ? ` - ${e.response.data.message}` : ''))
        } else if(
            !(e.code && e.code === "ERR_NETWORK") &&
            !e.hasOwnProperty('response')
        ) {
            throw new Error(e.message)
        }
    }
}


function* refreshSessionIfPossible(apiKey, initLoad) {
    try {
        const response = yield call(sessionRefreshCall, apiKey, { getCaps: initLoad})
        const valid = yield call(validSessionResponse, response)

        if(!valid) {
            throw new Error('Malformed refresh session response')
        }

        if(
            200 === response.status && 
            1 === response.data.state &&
            response.data.hasOwnProperty('caps') &&
            response.data.expired
        ) {
            yield call(putSessionData, response.data)

            if(initLoad)  {
                yield call(putCapsData, response.data.caps)
            }
        } else {
            throw new Error('Could not refresh token')
        }

    } catch(e)  {
        if(!e || !e.hasOwnProperty('response')) {
            throw new Error('Refresh session error')
        }

        const valid = yield call(validSessionResponse, e.response)

        if(valid && 403 === e.response.status) {
            yield e.response.data.expired = false
            yield call(putSessionData, e.response.data)
        }

        throw new Error('Refresh session error')
    }
}


function* checkAuth({payload}) {
    try {
        const apiKey = yield call(authUser.getToken)
        const initLoad = yield payload.initLoad

        if(!apiKey)  {
            throw new Error('No Auth token')
        }

        if(navigator.onLine) {
            yield call(validateIfPossible, apiKey)
            yield call(refreshSessionIfPossible, apiKey, initLoad)
        } else {
            const decodeToken = yield call(parseJWT, apiKey)

            if(
                !decodeToken 
                || !decodeToken.hasOwnProperty('exp')
                || decodeToken.exp < Math.floor(Date.now() / 1000)

            ) {
                throw new Error('Invalid token')
            }

            const isAlive = yield call(isSessionAlive)

            if(!isAlive) {
                throw new Error('Session not alive')
            }

            const isExpired = yield call(isSessionExpired)

            if(isExpired) {
                throw new Error('Session expired')
            }
        }

        yield putSuccess(actionTypes.AUTH_CHECK_SUCCESS )
    } catch(e) {
        yield putError(actionTypes.AUTH_CHECK_ERROR, e.message)
        yield put({
            type: actionTypes.AUTH_FLOW_LOGOUT_REQUEST_CLIENT
        })
    }
}


function* watchCheckAuth() {
    yield takeLatest(actionTypes.AUTH_CHECK_REQUEST, checkAuth);
}

export default watchCheckAuth